import { ReactComponent as Comment } from 'assets/icons/comment16.svg'
import { CreateCommentPrompt } from 'common/Prose/Prompts/CreateCommentPrompt/CreateCommentPrompt'
import {
  createTodoMark,
  createTodoSubmit,
  createTodoUuidOnNode,
} from 'common/Prose/Prompts/CreateTodoPrompt/createTodoSubmit'
import { NodeSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import React from 'react'
import { QueryClient } from 'react-query'
import { DocStore } from 'stores/DocStore'
import { ProseDropdownPrompt } from '../ProseDropdownPrompt/ProseDropdownPrompt'
import { NODES_WITH_TASKUUIDS } from '../TodoInlineFormatButton/TodoInlineFormatButton'
import { ButtonProps } from 'components/Button/Types'
import ButtonStyles from '../Buttons.module.scss'

export type CommentInlineFormatButtonProps = {
  view: EditorView
  layerId: string
  queryClient: QueryClient
  docStore: DocStore | null
  hide: boolean
  runItemKey?: string
  nodePos?: number
  onOpenChange?: (open: boolean) => void
  overrideSelectionRange?: { from: number; to: number }
  size?: ButtonProps['size']
  withLabel?: boolean
}

export const CommentItemKey = 'comment'

export const CommentInlineFormatButton: React.FC<React.PropsWithChildren<CommentInlineFormatButtonProps>> = (props) => {
  const {
    view,
    layerId,
    queryClient,
    docStore,
    hide,
    runItemKey,
    onOpenChange,
    nodePos,
    overrideSelectionRange,
    size = 'lg',
    withLabel,
  } = props
  if (!docStore || hide) return null

  const { from, to } = overrideSelectionRange ? overrideSelectionRange : view.state.selection

  const runNow = runItemKey === CommentItemKey

  const onSubmitTodo = (close: () => void) => {
    const todoOnNode =
      nodePos !== undefined &&
      view.state.selection instanceof NodeSelection &&
      NODES_WITH_TASKUUIDS.includes(view.state.selection.node.type as any)
    const callback = todoOnNode
      ? createTodoUuidOnNode(view, nodePos, close)
      : createTodoMark(view, close, overrideSelectionRange)
    return createTodoSubmit(from, to, docStore, callback)
  }

  return (
    <ProseDropdownPrompt
      size={size}
      view={view}
      anchorChildren={
        <div className={ButtonStyles.anchor}>
          <Comment /> {withLabel && <span className={ButtonStyles.label}>Comment</span>}
        </div>
      }
      label="Comment"
      shortcutKeys="M"
      shortcutModifiers={['Mod']}
      forceOpen={runNow}
      onOpenChange={onOpenChange}
      yOffset={4}
      dropdownComponent={(close) => {
        const handleClose = () => {
          close()
          view.focus()
        }

        return (
          <CreateCommentPrompt
            docStore={docStore}
            view={view}
            layerId={layerId}
            onSubmitTodo={onSubmitTodo(handleClose)}
            close={handleClose}
            queryClient={queryClient}
            overrideSelectionRange={overrideSelectionRange}
            richText
          />
        )
      }}
    />
  )
}
